export function calculateEwsPrice(row: any, loadout: number, interest: number, creditCard: boolean) {
  const n=(v:any)=>Number.isFinite(Number(v))?Number(v):0;
  const money=(v:number)=>Math.round((v+Number.EPSILON)*100)/100;
  const selected=(row.Lots||[]).filter((l:any)=>n(l.Bags)>0);
  const total=selected.reduce((v:number,l:any)=>v+n(l.Bags),0);
  if (n(loadout)<0 || n(interest)<0 || n(row.ActiveMonths)<0 || n(row.StaticMonths)<0 ||
      n(row.ProfitPerPound)<0 || selected.some((l:any)=>!Number.isInteger(Number(l.Bags)) || Number(l.Bags)>Number(l.UnsoldBags ?? Infinity))) {
    return {Bags:total,Cost:null,Profit:null,Finance:null,Ask:null};
  }
  if (!total || selected.some((l:any)=>l.CostPerPound==null || n(l.CostPerPound)<=0)) return {Bags:total,Cost:null,Profit:null,Finance:null,Ask:null};
  const cost=selected.reduce((v:number,l:any)=>v+n(l.Bags)*n(l.CostPerPound),0)/total;
  const margin=n(row.MarginPct)/100;
  if (row.ProfitMode==='MARGIN' && (margin<0 || margin>=1)) return {Bags:total,Cost:money(cost),Profit:null,Finance:null,Ask:null};
  const profit=row.ProfitMode==='MARGIN'?money(cost/(1-margin)-cost):n(row.ProfitPerPound);
  const monthly=cost*(n(interest)/100)/12+0.01;
  const finance=money(monthly*n(row.ActiveMonths)/2)+money(monthly*n(row.StaticMonths));
  const subtotal=cost+Math.max(0,n(loadout))+profit+finance;
  return {Bags:total,Cost:money(cost),Profit:money(profit),Finance:money(finance),Ask:money(creditCard?subtotal/.97:subtotal)};
}
